// ---------------------------------------------- Old Code -----------------------------------------------------------------

import { setIpoHomePageLIstData, startMasterLoding, stopMasterLoding } from '../store/slice/masterSlice'
import {
  Images,
  useCallback,
  React,
  Link,
  Components,
  icons,
  useEffect,
  useState,
  commonFunctions,
  toast,
  useSelector,
  useDispatch,
  removeLoginData,
  removeProfileData,
  useRef,
  setIpoData,
  getIpoList,
  setError,
  stopLoading,
  clearError,
  startLiveLoading,
  getIpoLiveDataPage,
  setliveIpoData,
  setLivePageSize,
  setLivePaginationLink,
  stopLiveLoading,
  setLiveprevious,
  setlivenext,
  setLivePageNo,
  setListedIpoData,
  setListedPageSize,
  setListedPaginationLink,
  setListedPageNo,
  setListednext,
  setListedprevious,
  stopListedLoading,
  setUpcomingIpoData,
  setUpcomingPageSize,
  setUpcomingPaginationLink,
  setUpcomingPageNo,
  setUpcomingnext,
  setUpcomingprevious,
  stopUpcomingLoading,
  setNewsPageSize,
  setNewsPageData,
  setNewsPaginationLink,
  getNewspage,
  setNewsPageNo,
  NewsStopPageLoading,
  NewsStartLoading,
  NewsStopLoading,
  setNewsData,
  stopFaqLoading,
  setFaqData,
  startFaqLoading
} from '../utils/npm'

import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { removeLastNumberFromUrl } from '../utils/utils'
import { useLayoutEffect } from 'react'
import { faqListApi, getNewsList, homePageIpoList } from '../api/IposApi'
import { MdAccountBalance } from 'react-icons/md'

const { ScrollToTop } = commonFunctions
const { Button } = Components
const { downArrow } = Images
const {
  RiMenuAddLine,
  FaRegUserCircle,
  FaUser,
  IoLogOut,
  IoClose,
  FaChevronDown,
  FaUserTie,
  FaCircleUser,
  FaHandPointRight,
  FaArrowRightLong,
  MdDelete
} = icons

const Header = () => {
  const [scrollClass, setScrollClass] = useState('')
  const navigate = useNavigate()
  const handleLoginRegister = useCallback(eve => {
    eve.preventDefault()
    navigate('/login')
  }, [])

  const { page } = useParams();
  const [navToggle, setNavToggle] = useState(false);

  // const [loginDetails, setLoginDetails] = useState(
  //   localStorage?.getItem('login')
  //     ? JSON.parse(localStorage.getItem('login'))
  //     : {}
  // )

  const { loginData, profileData } = useSelector(state => state.loginProfile)

  const loginDetails = localStorage?.getItem('profile')
    ? JSON.parse(localStorage?.getItem('profile'))
    : localStorage?.getItem('login')
      ? JSON.parse(localStorage?.getItem('login'))
      : {}

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      if (currentScrollY > 50) {
        setScrollClass('sticky_nav')
      } else {
        setScrollClass('')
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const navbarLinkClass = 'font-medium'
  const navItems = [
    { to: '/', label: 'Home', name: '' },
    {
      to: '/',
      label: 'IPOs',
      name: 'liveupcominglisted',
      subItems: [
        { to: '/live', label: 'Current IPO', name: 'live', auth: false },
        { to: '/upcoming', label: 'Upcoming IPO', name: 'upcoming', auth: false },
        { to: `/listed/${page || 1}`, label: 'Listed IPO', name: 'listed', auth: false },
        { to: '/appliedIpo', label: 'Applied Ipo List', name: 'listed', auth: true }
      ]
    },
    { to: '/news/1', label: 'News', name: 'news' },
    { to: '/broker', label: 'Brokers', name: 'broker' },
    { to: '/about-us', label: 'About Us', name: 'about-us' },
    { to: '/contactUs', label: 'Contact Us', name: 'contactUs' }
  ]

  const profileDropDown = [
    {
      to: '/profile',
      label: 'My Profile',
      icon: <FaUser />
    },
    // {
    //   to: '/account_page',
    //   label: 'My Demat Account',
    //   icon: <MdAccountBalance/>
    // },
    {
      to: '/',
      label: 'Log Out',
      icon: <IoLogOut />
    }
  ]

  const [active, setActive] = useState('')
  const location = useLocation()
  const [profie, setProfile] = useState(false)

  const dispatch = useDispatch()

  const handleNavBar = () => {
    setActive('active')
  }

  const handleClose = () => {
    setActive('')
  }

  const handleNavLink = (e, ele) => {
    setActive('')
    if (ele.to === '/') {
      dispatch(removeLoginData())
      dispatch(removeProfileData())
      navigate('/')
      toast.success('Logout SuccessFully.')
    }
  }

  const takeToken = JSON?.parse(localStorage?.getItem('login'))

  useEffect(() => {
    let res = JSON?.parse(localStorage?.getItem('login'))
    if (res?.access !== undefined) {
      setProfile(true)
      if (res.toast === false) {
        localStorage.setItem('login', JSON.stringify(res))
      }
    } else {
      setProfile(false)
    }
  }, [takeToken])

  useEffect(() => {
    ScrollToTop();
  }, [location.pathname]);

  const [isDeropdown, setIsDropdown] = useState(false)

  const isActive = (path) => {
    const currentPath = location.pathname.replace("/", "");
    if (currentPath === path) return true;
    if (path && currentPath.includes(path)) return true;
    if ((path.length > 0 && currentPath.length > 0) && path.includes(currentPath)) return true
    return false;
  };

  // ----------------------------------------- Hemang Code ------------------------------------
  const isFetched = useRef(false);
  const { isloading } = useSelector((state) => state.masterSlice);
  const { data, loading, ipoCategory, ipotype } = useSelector((state) => state.ipoData);

  const {
    newsPageLoading,
    newsPageError,
    newsPageData,
    currentPage,
    pageSize,
    totalPage,
    nextUrl,
    previousUrl,
    newsPaginationLink,
    newsPageNo,
    newsPageSize
  } = useSelector(state => state.newsPage)


  const getIpoData = async () => {
    try {
      // dispatch(startLoading());
      const data = {
        ipo_type: ipotype,
        category: ipoCategory?.toLowerCase(),
        page_size: 15
      };
      const response = await getIpoList(data);
      if (
        response?.meta?.status_code === 200 &&
        response?.data?.results?.length > 0
      ) {
        dispatch(setIpoData(response.data.results));
        dispatch(clearError());
      } else {
        dispatch(setIpoData([]));
        dispatch(setError("An error occurred"));
      }
    } catch (error) {
      dispatch(setIpoData([]));
      dispatch(setError(error.message || "An error occurred"));
    } finally {
      dispatch(stopLoading());
    }
  };

  const getIpoLiveData = async (
    pageNo,
    pageSize,
    filterType,
    filterCategory
  ) => {
    // dispatch(startLiveLoading())
    try {

      const response = await getIpoLiveDataPage(
        pageNo,
        pageSize,
        filterType?.toLowerCase(),
        filterCategory?.toLowerCase()
      )
      const { results, next, previous, total_page } = response?.data || {}
      if (results?.length > 0) {
        dispatch(setliveIpoData(results))
        dispatch(setLivePageSize(total_page))
      } else {
        dispatch(setliveIpoData([]))
        dispatch(setLivePageSize(1))
      }
      if (next !== null) {
        let data = removeLastNumberFromUrl(next)
        dispatch(setLivePaginationLink(data?.updatedUrl))
      } else if (previous !== null) {
        let data = removeLastNumberFromUrl(previous)
        dispatch(setLivePaginationLink(data?.updatedUrl))
      } else {
        dispatch(setLivePaginationLink(''))
        dispatch(setLivePageNo(1))
      }
    } catch (error) {
      dispatch(setliveIpoData([]))
      dispatch(setlivenext(''))
      dispatch(setLiveprevious(''))
    }
    // dispatch(stopLiveLoading())
  }

  const getIpoListData = async (
    pageNo,
    pageSize,
    filterType,
    filterCategory
  ) => {
    // dispatch(startListedLoading())

    try {
      const response = await getIpoLiveDataPage(
        pageNo,
        pageSize,
        filterType.toLowerCase(),
        filterCategory.toLowerCase()
      )
      const { results, next, previous, total_page } = response?.data || {}
      // Update live data
      if (results?.length > 0) {
        dispatch(setListedIpoData(results))
        dispatch(setListedPageSize(total_page))
      } else {
        dispatch(setListedIpoData([]))
        dispatch(setListedPageSize(1))
      }

      if (next !== null) {
        let data = removeLastNumberFromUrl(next)
        dispatch(setListedPaginationLink(data?.updatedUrl))
        // dispatch(setListedPageNo(+data?.pageNo - 1))
      } else if (previous !== null) {
        let data = removeLastNumberFromUrl(previous)
        dispatch(setListedPaginationLink(data?.updatedUrl))
        // dispatch(setListedPageNo(+data?.pageNo + 1))
      } else {
        dispatch(setListedPaginationLink(''))
        dispatch(setListedPageNo(1))
      }
      dispatch(stopListedLoading())
    } catch (error) {
      dispatch(setListedIpoData([]))
      dispatch(setListednext(''))
      dispatch(setListedprevious(''))
      dispatch(stopListedLoading())
    }
    // dispatch(stopListedLoading())
  }

  const getIpoUpcommingData = async (
    pageNo,
    pageSize,
    filterType,
    filterCategory
  ) => {
    // dispatch(startUpcomingLoading())
    try {
      const response = await getIpoLiveDataPage(
        pageNo,
        pageSize,
        filterType?.toLowerCase(),
        filterCategory.toLowerCase()
      )
      const { results, next, previous, total_page } = response?.data || {}
      // Update live data
      if (results?.length > 0) {
        dispatch(setUpcomingIpoData(results))
        dispatch(setUpcomingPageSize(total_page))
      } else {
        dispatch(setUpcomingIpoData([]))
        dispatch(setUpcomingPageSize(1))
      }

      if (next !== null) {
        let data = removeLastNumberFromUrl(next)
        dispatch(setUpcomingPaginationLink(data?.updatedUrl))
        // dispatch(setUpcomingPageNo(data?.pageNo - 1))
      } else if (previous !== null) {
        let data = removeLastNumberFromUrl(previous)
        dispatch(setUpcomingPaginationLink(data?.updatedUrl))
        // dispatch(setUpcomingPageNo(+data?.pageNo + 1))
      } else {
        dispatch(setUpcomingPaginationLink(''))
        dispatch(setUpcomingPageNo(1))
      }
    } catch (error) {
      dispatch(setUpcomingIpoData([]))
      dispatch(setUpcomingnext(''))
      dispatch(setUpcomingprevious(''))
    }
    dispatch(stopUpcomingLoading())
  }

  const newsList = async () => {
    try {
      dispatch(NewsStartLoading())
      const resposne = await getNewsList({ page_size: 8 })
      if (resposne.meta.status_code === 200) {
        // setData(resposne?.data)
        dispatch(setNewsData(resposne?.data?.results))
        if (
          resposne?.data?.results?.length === 0 &&
          resposne?.data?.results?.length === undefined
        ) {
          // setNoData(false)
        }
      }
      dispatch(NewsStopLoading())
      return resposne;
    } catch (error) {
      // setNoData(true)
      dispatch(NewsStopLoading())
      return error
    }
  }

  const getFaqList = async () => {
    dispatch(startFaqLoading())
    try {
      const response = await faqListApi()
      if (response.meta.status_code === 200) {
        dispatch(setFaqData(response?.data?.results))
      }
    } catch (error) {
      console.log(error)
    }
    dispatch(stopFaqLoading())
  }
  // const fetchNewsData = async (pageNo, pageSize) => {
  //   // dispatch(NewsStartPageLoading())
  //   try {
  //     const response = await getNewspage(pageNo, pageSize)
  //     const { results, next, previous, total_page } = response?.data || {}
  //     // Update live data
  //     if (results?.length > 0) {
  //       dispatch(setNewsPageData(results))
  //       dispatch(setNewsPageSize(total_page))
  //     } else {
  //       dispatch(setNewsPageData([]))
  //     }

  //     if (next !== null) {
  //       let data = removeLastNumberFromUrl(next)
  //       dispatch(setNewsPaginationLink(data?.updatedUrl))
  //       // dispatch(setNewsPageNo(data?.pageNo - 1))
  //     } else if (previous !== null) {
  //       let data = removeLastNumberFromUrl(previous)
  //       dispatch(setNewsPaginationLink(data?.updatedUrl))
  //       // dispatch(setNewsPageNo(+data?.pageNo + 1))
  //     } else {
  //       dispatch(setNewsPaginationLink(''))
  //       dispatch(setNewsPageNo(1))
  //     }
  //   } catch (error) {
  //     dispatch(setNewsPageData([]))
  //     dispatch(setNewsPageNo(1))
  //     dispatch(setNewsPageSize(1))
  //   }
  //   dispatch(NewsStopPageLoading())
  // }

  const getFetchHomePageListAPI = async (pageNo, pageSize) => {
    try {

      // dispatch(startMasterLoding(true));
      const data = {
        // ipo_type: ipotype,
        // category: selectedCategory
      };
      const response = await homePageIpoList(pageNo, pageSize);
      if (
        response.meta.status_code === 200 &&
        response.data.results !== undefined
      ) {
        console?.log('response.data?.results', response.data?.results)
        dispatch(setIpoHomePageLIstData(response.data?.results))
      } else {
        dispatch(setIpoHomePageLIstData([]))
        dispatch(setError("An error occurred")); // Handle error case
      }
    } catch (error) {
      dispatch(setIpoHomePageLIstData([]))
    }
  };

  useLayoutEffect(() => {
    const loadData = async () => {
      try {
        if (isFetched.current) return;
        isFetched.current = true;
        // dispatch(startMasterLoding(true));
        await Promise.all([
          getIpoData(),
          newsList(),
          getFaqList(),
          // getIpoLiveData(1, 30, 'liveIpoType', 'live'),
          // getIpoListData(1, 30, 'Listedipotype', 'listed'),
          // getIpoUpcommingData(1, 30, 'Upcomingipotype', 'upcoming'),
          // fetchNewsData(1, pageSize),
          // getFetchHomePageListAPI()
        ]);
        // Stop loading after all data has been fetched
        // dispatch(stopMasterLoding(false));
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(stopMasterLoding(false));  // Stop loading even in case of error
      }
    };
    loadData();
  }, []);

  return (
    <header
      className={`${location.pathname === '/' ? 'bg_header ' : 'bg_header '
        } ${scrollClass}`}
    >
      <div className='navBar navBar_pad'>
        <div className='container lg:px-5 '>
          <div className='flex justify-between items-center'>
            <div>
              <Link to='/'>
                <img
                  src={Images?.logo}
                  alt='logo'
                  loading='lazy'
                  className='header_logo'
                  width={203}
                  height={50}
                />
              </Link>
            </div>
            {/* Navbar Links */}
            <div className='relative'>
              <div className='hamburger' onClick={eve => handleNavBar(eve)}>
                <RiMenuAddLine className='text-3xl text-white' />
              </div>
              <ul className={`flex navbar_list items-center ${active}`}>
                <li className='hamburger '>
                  <IoClose
                    onClick={eve => handleClose(eve)}
                    className='ms-auto text-3xl'
                  />
                </li>
                {navItems.map((item, index) => (
                  <li
                    key={index}
                    className={
                      item.subItems ? 'submenu_sec cursor-pointer relative' : ''
                    }
                  >
                    <Link
                      to={item.subItems ? '#' : item.to}
                      onClick={(eve) => {
                        if (!item.subItems) {
                          handleClose(eve);
                        }
                        // dispatch(setHeaderLoad(false));
                        setIsDropdown(false)
                      }}
                      // onClick={eve => (item.subItems ? '' : handleClose(eve))}
                      // onClick={(eve) => {
                      //   if (!item.subItems) {
                      //     handleClose(eve);
                      //     dispatch(setHeaderLoad(false));
                      //   }
                      // }}
                      className={`${navbarLinkClass} ${item.subItems ? 'flex items-center' : ''
                        } ${isActive(item.name) ? 'active' : ''}`}
                    >
                      {item.label}{' '}
                      {item.subItems && (
                        <span className=''>
                          <FaChevronDown className='ps-2  text-xl' />
                        </span>
                      )}
                    </Link>
                    {!isDeropdown && item.subItems && (
                      <ul className='submenu absolute shadow-xl'>
                        {item.subItems.map((subItem, subIndex) => {
                          return subItem.auth ? (profie && <li key={subIndex}>
                            <Link
                              to={subItem.to}
                              className={`font-medium flex items-center py-0 ${isActive(subItem.name) ? 'active-class' : ''}`}
                              onClick={(eve) => {
                                handleNavBar(eve);
                                // dispatch(setHeaderLoad(true));
                                setIsDropdown(true)

                              }}
                            >
                              {subItem.label}
                            </Link>
                          </li>) : <li key={subIndex}>
                            <Link
                              to={subItem.to}
                              className={`font-medium flex items-center  py-0 ${isActive(subItem.name) ? '' : ''}`}
                              // onClick={eve => handleClose(eve)}
                              onClick={(eve) => {
                                handleNavBar(eve);
                                // dispatch(setHeaderLoad(true));
                                setIsDropdown(true)
                              }}
                            >
                              {subItem.label}
                            </Link>
                          </li>
                        })}
                      </ul>
                    )}
                  </li>
                ))}

                {profie && (
                  <>
                    <li className='submenu_sec relative cursor-pointer profile_menu'>
                      <Link className={`${navbarLinkClass} `}>
                        {/* Profile */}
                        <div className='flex items-center'>
                          <FaRegUserCircle className='text-2xl' />
                          <span className=''>
                            <img
                              src={downArrow}
                              className='ps-2 downIposArrow'
                              alt=''
                              loading='lazy'
                            />
                            <FaChevronDown className='ps-3 downIposArrow_mobile text-2xl' />
                          </span>
                        </div>
                      </Link>
                      <ul className='submenu_profile absolute shadow-xl'>
                        <li className='profile_section'>
                          <Link className='font-medium'>
                            <div className='flex items-center font-medium'>
                              {loginDetails?.profile_image === null ||
                                loginDetails?.profile_image === undefined ? (
                                <FaCircleUser style={{ fontSize: '30px' }} />
                              ) : (
                                <img
                                  src={loginDetails?.profile_image}
                                  alt='profile_image'
                                  className='profile_image'
                                />
                              )}
                              <div className='ps-4'>
                                <p className='text-lg pb-0 profile_first_last_name'>
                                  {profileData?.first_name ||
                                    loginData?.first_name}{' '}
                                  {profileData?.last_name ||
                                    loginData?.last_name}{' '}
                                </p>
                                <p className='text-xs pb-0 profile_first_last_name'>
                                  {loginDetails?.email}{' '}
                                </p>
                              </div>
                            </div>
                          </Link>
                        </li>
                        {profileDropDown.map((ele, index) => {
                          return (
                            <li key={index} className={`profile_menu_li ${(ele.to === location.pathname && ele.label !== "Log Out") ? "active" : ""}`}>
                              {/* className={`${isActive(item.name) ? 'active' : ''}`} */}
                              <Link
                                to={ele.to}
                                className='font-medium'
                                onClick={e => handleNavLink(e, ele)}
                              >
                                <p className='flex items-center font-medium'>
                                  {ele.icon}
                                  {ele.label}
                                </p>
                              </Link>
                            </li>
                          )
                        })}
                      </ul>
                    </li>
                  </>
                )}
                {!profie && (
                  <li className='login_register_link'>
                    <Link to={''}>
                      <Button
                        handleClick={handleLoginRegister}
                        classList={'auth_submit_login'}
                        content='Login'
                      />
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  )

}

export default Header;

